import service from '@/api/service/service';
import qs from "qs";

/* 查询球探信息 */
export function checkStudentExit(params) {
  return service({
    url: '/api/index/checkScout.json',
    method: 'GET',
    params
  })
}

/* 获取球探报告列表 */
export function getScoutReportList(params) {
  return service({
    url: '/api/index/reportList.json',
    method: 'GET',
    params
  })
}

/* 获取比赛列表 */
export function getCompetionList() {
  return service({
    url: '/api/index/competitionList.json',
    method: 'GET',
  })
}

/* 获取报告球探球员信息 */
export function getReportMansInfo(params) {
  return service({
    url: '/api/index/reportInfoView.json',
    method: 'GET',
    params
  })
}

/* 获取报告五环指标信息 */
export function getReportIndicatorsInfo(params) {
  return service({
    url: '/api/index/reportScoreInfo.json',
    method: 'GET',
    params
  })
}

/* 提交球探信息信息 */
export function postScoutInfo(data) {
  return service({
    url: '/api/index/reportSaveTwo.json',
    method: 'POST',
    data: qs.stringify(data)
  })
}

/* 编辑球探报告信息（从第二步开始，其他不变） */
export function putScoutInfo(data) {
  return service({
    url: '/api/index/reportSaveTwoEdit.json',
    method: 'POST',
    data: qs.stringify(data)
  })
}

/* 获取球员列表 */
export function getPlayerList(params) {
  return service({
    url: '/api/index/competitionPlayerList.json',
    method: 'GET',
    params
  })
}

/* 获取报告详情 */
export function getReportDetails(params) {
  return service({
    url: '/api/index/reportInfo.json',
    method: 'GET',
    params
  })
}

/* 提交球员信息 */
export function postPlayerInfo(data) {
  return service({
    url: '/api/index/reportSaveThree.json',
    method: 'POST',
    data: qs.stringify(data)
  })
}

/* 获取五环指标 */
export function getFiveRingsInfo() {
  return service({
    url: '/api/index/reportIndicators.json',
    method: 'GET'
  })
}

/* 提交五环指标报告评分 */
export function postFiveRingsReport(data)  {
  return service({
    url: '/api/index/reportSaveFour.json',
    method: 'POST',
    data: qs.stringify(data)
  })
}

/* 提交主观评价 */
export function postSubjectiveComments(data) {
  return service({
    url: '/api/index/reportSaveFive.json',
    method: 'POST',
    data: qs.stringify(data)
  })
}

/* 删除报告列表 */
export function delteReport(data) {
  return service({
    url: '/api/index/reportDelete.json',
    method: 'POST',
    data: qs.stringify(data)
  })
}

/* 下载 */
export function getPdfUrl(params) {
  return service({
    url: '/api/index/view_pdf_download.json',
    method: 'GET',
    params
  })
}